// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const PlannerCreatePlanModalContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "planner-createplanmodalcontainer" */ "./PlannerCreatePlanModalContainer")).then((bundle)=>{
        return {
            default: bundle.PlannerCreatePlanModalContainer
        };
    });
export const LazyPlannerCreatePlanModalContainer = /*#__PURE__*/ lazy(PlannerCreatePlanModalContainerLazyLoader);
